export const productsContent = {
  hero: {
    title: "Products",
    subtitle: "From plug-and-play tablets to bring-your-own-device, we have options that fit your family's home."
  },
  displayOptions: {
    title: "Display Options",
    subtitle: "Choose the hardware and apps that work for your family. Mix and match as needed.",
    products: [
      {
        id: "managed-tablet",
        name: "Managed Tablet",
        tagline: "$99 one-time purchase",
        image: "/images/fcast-tablet.jpeg",
        description: "A ready-to-run Android tablet with FamilyCast pre-installed. Turn it on, pair it to your account, and you're displaying content in minutes. We handle the device management so you don't have to.",
        features: [
          "Pre-configured and ready to use",
          "Automatic updates and security patches",
          "Remote management and kiosk mode included",
          "12-month replacement warranty with active subscription",
          "Wall-mount or counter-stand options"
        ],
        cta: "Learn More",
        ctaLink: "/contact"
      },
      {
        id: "managed-stick",
        name: "Managed HDMI Stick",
        tagline: "$75 one-time purchase",
        image: "/images/fc-hdmi-stick.jpeg",
        description: "A compact Android media player that plugs into any TV or monitor with an HDMI port. Same fully-managed experience as our tablets, but for your existing screens.",
        features: [
          "Works with any TV or monitor",
          "Same easy setup as managed tablets",
          "Automatic updates and remote management",
          "12-month replacement warranty with active subscription",
          "Great for living rooms and family spaces"
        ],
        cta: "Learn More",
        ctaLink: "/contact"
      },
      {
        id: "android-app",
        name: "FamilyCast App",
        tagline: "$0 hardware cost",
        image: "/images/familycast_logo_1000x1000.png",
        description: "Bring your own Android device, install our app, and add it to your FamilyCast subscription. Works on any Android 10+ tablet, TV stick, or media player you already own.",
        features: [
          "No hardware purchase required",
          "Works on Android 10+ devices",
          "Same features as managed hardware",
          "You handle device setup and maintenance",
          "Ideal if you have existing devices"
        ],
        cta: "Learn More",
        ctaLink: "/contact"
      },
      {
        id: "browser-pwa",
        name: "Browser Display",
        tagline: "$0 hardware cost",
        image: "/images/fcast-tablet.jpeg",
        description: "Run FamilyCast on any device with a modern web browser. No app to install—just open a URL and go. Perfect for repurposing old laptops, iPads, or any screen you have around the house.",
        features: [
          "No hardware purchase required",
          "Works on any device with a browser",
          "No app installation needed",
          "Great for testing or temporary displays",
          "Same content as native apps"
        ],
        cta: "Learn More",
        ctaLink: "/contact"
      }
    ]
  },
  addOns: {
    title: "Add-Ons",
    subtitle: "Optional products to make family life even easier. Coming soon.",
    products: [
      {
        id: "chore-board",
        name: "Chore & Reward Board",
        tagline: "Add-on product",
        image: "/images/fcast-choreboard.jpeg",
        description: "Turn chores into a game. Assign tasks to family members, track completion, and reward kids for getting things done. Visual progress tracking makes responsibility fun.",
        features: [
          "Assign chores to any family member",
          "Track completion with visual checkmarks",
          "Set up reward points and milestones",
          "Age-appropriate task suggestions",
          "Weekly and monthly progress views"
        ],
        cta: "Join Beta for Early Access",
        ctaLink: "/beta",
        status: "Coming Soon"
      },
      {
        id: "meal-planning",
        name: "Meal Planning",
        tagline: "Add-on product",
        image: "/images/fcast-meal-planning.jpeg",
        description: "Plan your weekly meals, display today's menu, and generate shopping lists automatically. Integrates with your calendar so the whole family knows what's for dinner.",
        features: [
          "Weekly meal planning calendar",
          "Auto-generated shopping lists",
          "Display today's meals on your screens",
          "Recipe storage and favorites",
          "Dietary preferences and allergies tracking"
        ],
        cta: "Join Beta for Early Access",
        ctaLink: "/beta",
        status: "Coming Soon"
      }
    ]
  },
  comparison: {
    title: "Hardware Options Comparison",
    headers: ["", "Managed Tablet", "Managed HDMI Stick", "FamilyCast App", "Browser Display"],
    rows: [
      { feature: "Hardware cost", values: ["$99", "$75", "$0", "$0"] },
      { feature: "Setup", values: ["Boot → pair", "Plug in → pair", "Install → pair", "Open URL → pair"] },
      { feature: "Device management", values: ["We handle it", "We handle it", "You handle it", "You handle it"] },
      { feature: "Replacement warranty", values: ["12 months", "12 months", "N/A", "N/A"] },
      { feature: "Best for", values: ["Kitchen & hallway", "Living room TVs", "Existing Android", "Any device"] }
    ]
  },
  cta: {
    title: "Not Sure Which to Choose?",
    description: "Tell us about your home setup and we'll help you figure out the best options. No pressure, no sales pitch—just honest advice.",
    buttonText: "Let's Talk",
    buttonLink: "/contact"
  }
};
